<!--suppress ES6ModulesDependencies -->
<template>
    <v-container :style="cssProps">
        <h1 class="titulo mb-3">Contrato</h1>

        <v-stepper class="card" v-model="current_page">
            <v-row justify="center"
                   class="header-steps">
                <v-col class="d-flex steps-container">
                    <template v-for="(step, i) in Steps">
                        <v-stepper-step :key="i" class="flex justify-center" :complete="current_page > i+1" :step="i+1">
                            <p class="step-label titulo">
                                <v-icon>{{ step.icon }}</v-icon>
                                {{ step.text }}
                            </p>
                        </v-stepper-step>
                    </template>
                </v-col>
            </v-row>
            <v-stepper-items class="step-content">
                <ResumoContrato v-if="m_tela === RESUMO" :value="id_pedido" @nextPage="irParaAssinatura()" @prevPage="$listeners.prevPage" @finalizado="$listeners.finalizado" />
                <AssinaturaContrato v-if="m_tela === SELECIONAR_ASSINATURA" :value="id_pedido" @nextPage="$listeners.nextPage" @prevPage="irParaResumo()" @finalizado="$listeners.finalizado" />
            </v-stepper-items>
        </v-stepper>
    </v-container>
</template>

<script>
  import ResumoContrato from '@/views/cadastro/contrato/ResumoContrato'
  import AssinaturaContrato from '@/views/cadastro/contrato/AssinaturaContrato'
  import { swap } from '@/plugins/helpers'
  import Color from 'color'
  import { colorRes } from '@/plugins/flavors'
  import { mapState } from 'vuex'

  export default {
    name: 'ContratoVenda',
    components: { ResumoContrato, AssinaturaContrato },
    data: () => ({
      m_tela: '',
      current_page: 5,
      id_pedido: 0
    }),
    computed: {
      SELECIONAR_ASSINATURA: () => 'selecionar_assinatura',
      RESUMO: () => 'selecionar_resumo',
      ...mapState(['permite_multiplicar_cota']),
      Steps () {
        let Steps = [
          { icon: 'rod-cadastro', text: 'Cadastro' },
          { icon: 'rod-produto', text: 'Produto' },
          { icon: 'rod-grupo', text: 'Grupo' },
          { icon: 'ol-book', text: 'Confirmação' },
          { icon: 'gesture', text: 'Contrato' },
          { icon: 'rod-cartao', text: 'Pagamento' },
          { icon: 'rod-cadastro', text: 'Cotas' }
        ]
        if (this.exibirAssinaturaContrato && this.exibirContratoAlocacao) {
          Steps = swap(Steps, 4, 5)
        }
        if (this.fluxoProduto) {
          Steps = swap(Steps, 0, 1)
          return swap(Steps, 1, 2)
        }
        if (this.permite_multiplicar_cota) {
          Steps.splice(5, 0)
        }
        return Steps
      },
      cssProps () {
        return {
          '--secondaryTransparent': Color(colorRes().secondary).alpha(0.15),
          '--primaryTransparent': Color(colorRes().primary).alpha(0.15)
        }
      }
    },
    watch: {
      tela (val) {
        this.m_tela = val
      }
    },
    mounted () {
      this.id_pedido = this.$session.get('id_pedido_detalhes_venda')
      this.m_tela = 'selecionar_assinatura'
    },
    methods: {
      reload (reload) {
        this.id_pedido = this.$session.get('id_pedido_detalhes_venda')

        this.$emit('reload', reload)
      },
      irParaAssinatura () {
        this.m_tela = this.SELECIONAR_ASSINATURA
      },
      irParaResumo () {
        this.m_tela = this.RESUMO
      },
      irParaDadosBancarioouContrato () {
        if (this.pedido.assinatura_obrigatoria) {
          if (this.pedido.enviado) {
            this.tela_contrato = 'selecionar_assinatura'
          }
          this.current_page = this.Pages.Contrato
        } else {
          this.tela_confirmacao = 'selecionar_prazo_parcela'
          this.current_page = this.Pages.Confirmacao
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .header-steps {
        border-bottom: 1px solid var(--lightgray)
    }

    .steps-container {
        max-width: 1200px;
        border-bottom: 1px solid var(--lightgray);
        white-space: nowrap;
    }

    .steps-container .v-icon {
        vertical-align: middle;
        font-size: 18px;
        margin-right: 5px;
        margin-top: -2px;
    }

    .steps-container .step-label {
        display: block !important;
        text-transform: uppercase;
        font-size: 14px;
        margin-bottom: 0;
    }

    .steps-container .step-label, .steps-container .v-icon {
        color: var(--gray);
    }

    .steps-container .v-stepper__step--active {
        background: var(--secondaryTransparent);
    }

    .steps-container .v-stepper__step--active .step-label,
    .steps-container .v-stepper__step--active .v-icon {
        color: var(--secondary);
    }

    .steps-container .v-stepper__step--complete .step-label,
    .steps-container .v-stepper__step--complete .v-icon {
        color: var(--primary);
    }

    .step-content {
        padding: 15px;
    }
</style>

<!--suppress CssUnusedSymbol -->
<style>
    .v-stepper__step__step {
        display: none !important;
    }

    .v-stepper__label {
        display: block !important;
    }
</style>
